import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CompareService {
  public data: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor() {}
}
